module.exports = __webpack_public_path__ + "img/to-close-icon.2a8d0998.svg";